import React from 'react';
import FieldForm from '../../FieldForm/FieldForm';
import { GeneralSelect } from 'v2/form/CustomSelectors/GeneralSelect';
import { getCurrencyOptions } from 'v2/utils/dataProductsUtils';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';

const CurrencyField = (props: FieldTypeProps) => {
  const { value } = props;

  return (
    <FieldForm
      {...props}
      content={value}
      renderInput={({ field: { onChange, value } }) => {
        const options = getCurrencyOptions();
        const selected = options.find((option) => option.value === value);

        return (
          <GeneralSelect
            options={options}
            handleChange={(option) => onChange(option?.value)}
            selectedOption={selected}
          />
        );
      }}
    />
  );
};

export default CurrencyField;
